import type { ReactNode } from 'react';

const iconClasses = 'size-5 text-secondary';

export const iconsYabby = {
  checkmark: (
    <svg
      className={iconClasses}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  ),
  truck: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={iconClasses}
      fill="none"
      viewBox="0 0 24 24"
    >
      <title>Truck</title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.161 3h5.678c.527 0 .981 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.006.063.01.128.013.195h1.406c.19 0 .43-.001.665.055a2 2 0 0 1 .578.24c.206.126.375.296.509.43l.036.037 4.063 4.062.036.036c.134.134.304.303.43.51.11.178.19.373.24.577a2.8 2.8 0 0 1 .055.665v2.914c0 .21 0 .415-.012.59a2.03 2.03 0 0 1-.14.65 2 2 0 0 1-1.083 1.082c-.1.041-.198.07-.292.091a3.5 3.5 0 0 1-6.938.061h-3.661a4.002 4.002 0 0 1-7.781-.14A3.001 3.001 0 0 1 1 15V7.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C4.18 3 4.635 3 5.161 3ZM3.235 15.645a4.002 4.002 0 0 1 7.639.355H13V7.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C11.75 5 11.377 5 10.8 5H5.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C3 6.25 3 6.623 3 7.2V15c0 .246.089.47.235.645ZM15 15.696V8h1.337c.131 0 .197 0 .244.002h.004l.002.003c.035.032.082.078.175.17l4.062 4.063c.093.093.139.14.171.175l.002.002v.004c.003.047.003.113.003.244v3.033A3.498 3.498 0 0 0 18 14a3.5 3.5 0 0 0-3 1.696ZM7 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm11 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        clipRule="evenodd"
      />
    </svg>
  ),
} as const satisfies Record<string, ReactNode>;

export const iconNamesYabby = Object.keys(
  iconsYabby
) as (keyof typeof iconsYabby)[];
